// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iu","advertCardFooter__row":"c-a_iv","advertCardFooter__name":"c-a_iw","advertCardFooter__price":"c-a_ix","advertCardFooter__age":"c-a_iy"};